import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CircularProgress from "@mui/material/CircularProgress";
import { forgotPassword } from "../api/apiClient";
import { useTenant } from "../contexts/TenantContext";
import AuthLayout, { AuthAlert } from "./auth/AuthLayout";
import AuthField from "./auth/AuthField";

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const { domainTenant } = useTenant();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [tried, setTried] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setTried(true);
    if (!email.trim()) return;
    setLoading(true);
    setError(null);
    try {
      await forgotPassword(email.trim());
      setSubmitted(true);
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <AuthLayout domainTenant={domainTenant}>
        <div className="auth-ico">
          <MailOutlineIcon />
        </div>
        <h1>Check your email</h1>
        <p className="auth-sub">
          If <span className="auth-mail">{email.trim()}</span> is registered, a reset link has been
          sent. The link expires in 30 minutes.
        </p>
        <button
          type="button"
          className="auth-btn auth-btn--p"
          style={{ width: "100%" }}
          onClick={() => navigate("/login")}
        >
          Back to Sign In
        </button>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout domainTenant={domainTenant}>
      <h1>Reset your password</h1>
      <p className="auth-sub">
        Enter the email on your account and we&apos;ll send you a reset link if it&apos;s on file.
      </p>
      {error && <AuthAlert>{error}</AuthAlert>}
      <form className="auth-form" onSubmit={handleSubmit} noValidate>
        <AuthField
          id="email"
          label="Email Address"
          type="email"
          value={email}
          onChange={setEmail}
          autoComplete="email"
          error={tried && !email.trim() ? "Enter your email address." : ""}
        />
        <button className="auth-btn auth-btn--p" type="submit" disabled={loading}>
          {loading ? (
            <CircularProgress size={18} sx={{ color: "#fff" }} aria-label="Sending" />
          ) : (
            "Send Reset Link"
          )}
        </button>
      </form>
      <div className="auth-alt">
        <button type="button" className="auth-link" onClick={() => navigate("/login")}>
          Back to Sign In
        </button>
      </div>
    </AuthLayout>
  );
}
